// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3bmcI","list":"PatternAutocomplete_list__28j4V"};